import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PrescriptionIcon from "../../../../Assets/svg/prescription.svg";
import prescriptionStyles from "./UploadPrescription.module.css";

// import Drawer from "@mui/material/Drawer";
// import Login from "../../../Login/Login";
// import VerifyOtp from "../../../Login/VerifyOtp";
// import {
//   selecttoken,
//   selectloginSlider,
//   setloginSliderstate,
//   selectVerifySlider,
//   setVerifyOtpSliderstate,
//   selectOnCloseDisableLoginSlider
// } from "../../../../src/slice/LoginPageSlice";


const UploadPrescription = () => {
  // const dispatch = useDispatch();
  // const router = useRouter();

  // const loginSlider = useSelector(selectloginSlider);
  // const verifySlider = useSelector(selectVerifySlider);
  // const onCloseLoginSliderDeactive = useSelector(selectOnCloseDisableLoginSlider);

  const handlePrescriptionClick = () => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("user"));
      const token = userDetails && userDetails?.token;
      if (token) {
        // router.push('/uploadprescription')
        window.location.href = process.env.RAZZLE_APP_BASE_URL + "/uploadprescription";
      } else {
        window.location.href = process.env.RAZZLE_APP_BASE_URL;
        // dispatch(setloginSliderstate(true));
      }
    }
    catch {
      window.location.href = process.env.RAZZLE_APP_BASE_URL + "/uploadprescription";
      // console.log("Error")
    }
  };

  return (
    <>
      <div className={`${prescriptionStyles.container}`} onClick={handlePrescriptionClick}>
        <span className={prescriptionStyles.content}>
          <img src={PrescriptionIcon} className={prescriptionStyles.presIcon} />
          &nbsp; Upload Prescription
        </span>
      </div>
      {/* <Drawer
        anchor="right"
        open={loginSlider}
        onClose={() => {
          if (onCloseLoginSliderDeactive) {
            console.log("Cannot close slider")
          } else {
            dispatch(setloginSliderstate(false));
          }
        }}
      >
        <Login />
      </Drawer>
      <Drawer
        anchor="right"
        open={verifySlider}
        onClose={() => dispatch(setVerifyOtpSliderstate(false))}
      >
        <VerifyOtp />
      </Drawer> */}
    </>
  );
};

export default UploadPrescription;
